import React from 'react';

const WorkShop = ({ height, width, className, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 122.88 118.27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.77,9.18c-1.08,0-1.95-0.87-1.95-1.95c0-1.08,0.87-1.95,1.95-1.95h51.91V1.95c0-1.08,0.87-1.95,1.95-1.95
            c1.08,0,1.95,0.87,1.95,1.95v3.33h48.32c1.08,0,1.95,0.87,1.95,1.95c0,1.08-0.87,1.95-1.95,1.95h-4.49v49.8h4.7
            c1.08,0,1.95,0.87,1.95,1.95c0,1.08-0.87,1.95-1.95,1.95H65.85v5.53c0.1,0.07,0.17,0.14,0.24,0.21l11.95,11.36
            c0.77,0.73,0.8,1.99,0.07,2.75c-0.73,0.77-1.99,0.8-2.75,0.07l-9.48-9.02v9.89c0,1.08-0.87,1.95-1.95,1.95
            c-1.08,0-1.95-0.87-1.95-1.95V73.39l-9.89,9.41c-0.77,0.73-2.02,0.73-2.75-0.07c-0.73-0.77-0.73-2.02,0.07-2.75l11.95-11.36
            c0.17-0.17,0.42-0.31,0.63-0.42v-5.32H35.51c-1.08,0-1.95-0.87-1.95-1.95c0-1.08,0.87-1.95,1.95-1.95h69.99V9.18H9.77L9.77,9.18z
            M77.17,105.82c-8.69,0-2.97,0.68-1.78-8.76c1.77-14.12,15.19-14.12,17.17,0c1.27,9.08,6.72,8.76-1.78,8.76h-3.39
            c-0.01,2.31-0.37,3.49,2.03,4.79c1.22,0.66,3.5,1.16,5.45,1.92c2.97-2.54,8.24-0.87,8.79-5.52c0.08-0.71-1.59-3.41-1.97-4.71
            c-0.82-1.31-1.11-3.38-0.22-4.77c0.36-0.55,0.2-2.55,0.2-3.31c0-7.52,13.18-7.52,13.18,0c0,0.95-0.22,2.7,0.3,3.45
            c0.86,1.25,0.42,3.47-0.31,4.63c-0.47,1.36-2.24,3.94-2.09,4.71c1.28,6.51,10.15-0.46,10.15,11.25l-24.91,0l-0.01,0h-4.03h-1.08
            l-22.94,0l-0.01,0l-22.03,0v0l-27.8,0c0-11.91,11.24-5.31,12.1-12.61c0.09-0.8-1.78-3.82-2.21-5.28c-0.92-1.47-1.25-3.79-0.24-5.34
            c0.4-0.62,0.23-2.86,0.23-3.71c0-8.43,14.77-8.43,14.77,0c0,1.07-0.25,3.03,0.33,3.86c0.97,1.4,0.47,3.89-0.35,5.19
            c-0.52,1.53-2.51,4.41-2.34,5.28c0.62,3.15,8.47,5.29,11.21,6.45c1.54-0.79,2.79-1.73,2.92-2.82c0.07-0.57-1.27-2.72-1.57-3.76
            c-0.65-1.04-0.89-2.7-0.17-3.81c0.28-0.44,0.16-2.04,0.16-2.64c0-6,10.52-6.01,10.52,0c0,0.76-0.17,2.15,0.24,2.75
            c0.69,1,0.33,2.77-0.25,3.69c-0.37,1.09-1.79,3.14-1.67,3.76c0.77,3.94,5.03,1.7,7.04,4.45c1.9-1.5,5.68-1.91,7.99-3.29
            c2.11-1.26,1.75-2.53,1.74-4.63L77.17,105.82L77.17,105.82L77.17,105.82z M0.01,46.73c-0.28-5.43,4.18-6.86,10.24-6.48l7.66,8.53
            l7.49-8.43l18.57-0.1c7,0.8,5.54,8.15,0,8.43H31.82l-2.86,17.17L26.8,77.02c-0.56,1.85-1.67,3.03-3.31,3.66l-10.56,0.07
            c-2.13-0.31-3.38-1.57-3.76-3.76l-1.64-9.25c-4.32,0.42-5.78-2.65-6.24-7.07L0.05,46.7L0.01,46.73L0.01,46.73z M17.47,17.02
            c5.19,0,9.41,4.22,9.41,9.41s-4.22,9.41-9.41,9.41c-5.19,0-9.41-4.22-9.41-9.41S12.27,17.02,17.47,17.02L17.47,17.02z
            M17.81,44.78l-5.96-6.55l1.74-1.39c2.58,1.08,5.16,1.08,7.7,0l2.4,1.43L17.81,44.78L17.81,44.78z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export { WorkShop };